
/* Bio Restore core-set — restore interactive behaviour the page export stripped.
 *
 * 4 of the 5 reference exports contain ZERO <script> tags: SingleFile saved the rendered
 * DOM and dropped every behaviour with it. The MARKUP for each control survived (tabs,
 * carousels, their targets and their active-state CSS classes all exist) — only the
 * wiring is gone. So this is restoration against the structure already in the page, not
 * new UI: every selector and every class below was read off the reference, not invented.
 *
 * Each block is a no-op on pages that don't have that control.
 */
(function () {
  'use strict';

  /* --- 1. SECTION NAV TABS (two-types-listicle) -----------------------------------
   * section.data-nav > div.overview x4. The reference already carries #overview,
   * #results, #recommendation and #order on the matching content blocks, and a
   * .nav-active class with its own colour rule — it was only ever missing the JS. */
  (function navTabs() {
    var nav = document.querySelector('section.data-nav');
    if (!nav) return;
    var tabs = [].slice.call(nav.querySelectorAll('.overview'));
    if (!tabs.length) return;

    var targets = tabs.map(function (t) {
      var id = (t.textContent || '').trim().toLowerCase().replace(/[^a-z]/g, '');
      return document.getElementById(id);
    });
    var navH = nav.getBoundingClientRect().height || 40;

    tabs.forEach(function (tab, i) {
      if (!targets[i]) return;
      tab.style.cursor = 'pointer';
      tab.setAttribute('role', 'link');
      tab.setAttribute('tabindex', '0');
      function go(e) {
        e.preventDefault();
        var y = targets[i].getBoundingClientRect().top + window.scrollY - navH - 8;
        var from = window.scrollY;
        window.scrollTo({ top: y, behavior: 'smooth' });
        // Some engines (and reduced-motion settings) no-op `behavior:'smooth'` entirely
        // rather than jumping — which reads to the visitor as a dead tab. If nothing has
        // started moving by the next frames, land it instantly.
        setTimeout(function () {
          if (Math.abs(window.scrollY - from) < 2 && Math.abs(y - from) > 2) {
            window.scrollTo(0, y);
          }
          spy();   // don't make the clicked tab wait out the scroll throttle
        }, 120);
      }
      tab.addEventListener('click', go);
      tab.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') go(e);
      });
    });

    // scroll-spy: keep .nav-active on the section actually in view
    var spy = function () {
      var best = 0;
      targets.forEach(function (el, i) {
        if (el && el.getBoundingClientRect().top - navH - 40 <= 0) best = i;
      });
      tabs.forEach(function (t, i) { t.classList.toggle('nav-active', i === best); });
    };
    // Throttle on the clock, not on requestAnimationFrame: rAF is suspended whenever the
    // tab isn't painting, which would leave the active tab frozen on whatever section
    // happened to be current when the page loaded.
    var lastSpy = 0;
    window.addEventListener('scroll', function () {
      var now = Date.now();
      if (now - lastSpy < 100) return;
      lastSpy = now;
      spy();
    }, { passive: true });
    spy();
  })();

  /* --- 2. ARROW CAROUSELS (benefit-stack GemPages/Swiper, n-reasons) ---------------
   * Both builders render the slides, the clipping container and the two arrow <button>s,
   * and drive movement from JS that the export dropped.
   *
   * Move by SCROLLING the clipping container, not by transforming the track: the track's
   * transform is pinned by an `!important` rule from the builder's own stylesheet, so an
   * inline transform computes back to identity and the carousel silently doesn't move.
   * scrollLeft has no specificity to lose to — and it works on `overflow:hidden`.
   * Which ancestor actually scrolls differs per builder, so find it by measurement
   * (scrollWidth > clientWidth) instead of by class name. */
  (function arrowCarousels() {
    var roots = [].slice.call(document.querySelectorAll(
      'gp-carousel-v3, .logos-carousel-wrapper, [class*="carousel"], [class*="slider"]'));

    roots.forEach(function (root) {
      if (root.dataset.lgpCarousel) return;
      // Take the arrows even when they measure 0x0. The builder ships them
      // `display:none` and reveals them from the JS that initialises the carousel — so
      // on an export they are permanently hidden, and with no dots and no drag handler
      // the off-screen slides become unreachable. They are un-hidden below, but only
      // once we've confirmed there is genuinely something to scroll to.
      var btns = [].slice.call(root.querySelectorAll('button')).filter(function (b) {
        return !b.closest('a');
      });
      if (btns.length < 2) return;

      // Find the scroller BY MEASUREMENT, then read the slides off it. Going the other
      // way (guess the slides by class, walk up to a scroller) picks the wrong element:
      // `[class*="slide"]` also matches the track itself, and the track overflows its
      // box while being `overflow:visible`, i.e. it reports scrollable and isn't.
      var scroller = null;
      [].forEach.call(root.querySelectorAll('*'), function (el) {
        if (scroller) return;
        var ovf = getComputedStyle(el).overflowX;
        if (ovf !== 'hidden' && ovf !== 'auto' && ovf !== 'scroll') return;
        if (el.scrollWidth - el.clientWidth > 4) scroller = el;
      });
      if (!scroller) return;

      var track = scroller.firstElementChild || scroller;
      var slides = [].slice.call(track.children);
      if (slides.length < 2) { slides = [].slice.call(scroller.children); }
      if (slides.length < 2) return;

      root.dataset.lgpCarousel = '1';
      // slide pitch from two real slide positions — never assumed from width alone
      var pitch = Math.abs(Math.round(slides[1].getBoundingClientRect().left -
                                      slides[0].getBoundingClientRect().left));
      if (!pitch) pitch = Math.round(scroller.clientWidth / 2);

      // reveal the builder's own arrows, and make the strip swipeable/scrollable so the
      // control is not the ONLY way to reach the hidden slides
      btns.forEach(function (b) {
        var cs = getComputedStyle(b);
        if (cs.display === 'none') b.style.setProperty('display', 'flex', 'important');
        if (cs.visibility === 'hidden') b.style.setProperty('visibility', 'visible', 'important');
      });
      scroller.style.setProperty('overflow-x', 'auto', 'important');
      scroller.style.scrollbarWidth = 'none';
      scroller.style.scrollSnapType = 'x mandatory';
      slides.forEach(function (s) { s.style.scrollSnapAlign = 'start'; });

      function paint() {
        var max = scroller.scrollWidth - scroller.clientWidth;
        btns[0].disabled = scroller.scrollLeft <= 1;
        btns[1].disabled = scroller.scrollLeft >= max - 1;
        btns.forEach(function (b) {
          b.style.opacity = b.disabled ? '.35' : '';
          b.style.cursor = b.disabled ? 'default' : 'pointer';
        });
      }
      function nudge(dir) {
        return function (e) {
          e.preventDefault();
          var target = scroller.scrollLeft + dir * pitch;
          try { scroller.scrollTo({ left: target, behavior: 'smooth' }); }
          catch (err) { scroller.scrollLeft = target; }
          setTimeout(function () {
            if (Math.abs(scroller.scrollLeft - target) > 4) scroller.scrollLeft = target;
            paint();
          }, 140);
        };
      }
      btns[0].addEventListener('click', nudge(-1));
      btns[1].addEventListener('click', nudge(1));
      scroller.addEventListener('scroll', paint, { passive: true });
      window.addEventListener('resize', paint);
      paint();
    });
  })();

  /* --- 2b. CAROUSELS WHOSE SLIDES WERE NEVER EXPORTED ------------------------------
   * Replo virtualises its carousels: only the active slide is ever in the DOM, and the
   * rest are re-rendered from the page payload. An export therefore captures ONE slide
   * while keeping the arrows and the full dot strip — n-reasons has a before/after
   * carousel announcing "Slide 1 of 5" with four slides that do not exist.
   *
   * Wiring cannot fix that; there is nothing to scroll to. Reconstructing the missing
   * slides is an image job (they are the source brand's before/afters), not this file's.
   * So the honest fix is to stop the page ADVERTISING what it can't deliver: hide the
   * arrows and the dot strip, leave the one real slide. A control that does nothing is
   * worse than no control — it reads as a broken page. Flagged in the image manifest. */
  (function pruneVirtualisedCarousels() {
    var arrows = [].slice.call(document.querySelectorAll(
      'button[aria-label*="slide" i], button[aria-label*="Slide"]'));
    var groups = [];
    arrows.forEach(function (b) {
      var host = b.closest('[class]') && b.parentElement && b.parentElement.parentElement;
      if (host && groups.indexOf(host) < 0) groups.push(host);
    });
    groups.forEach(function (host) {
      var sr = host.querySelector('.replo-sr-only');
      var announced = sr && /of\s+(\d+)/i.exec(sr.textContent || '');
      var total = announced ? parseInt(announced[1], 10) : 0;
      // count real slides: the viewport's track children
      var viewport = [].slice.call(host.children).filter(function (c) {
        var o = getComputedStyle(c).overflowX;
        return o === 'clip' || o === 'hidden' || o === 'auto';
      })[0];
      var present = viewport && viewport.firstElementChild
        ? viewport.firstElementChild.children.length : 0;
      if (total > 1 && present <= 1) {
        [].forEach.call(host.querySelectorAll('button[aria-label*="lide"]'), function (b) {
          b.style.setProperty('display', 'none', 'important');
        });
        // the dot strip: a sibling holding exactly `total` small children
        [].forEach.call(host.children, function (c) {
          if (c !== viewport && c.children.length === total) {
            c.style.setProperty('display', 'none', 'important');
          }
        });
        host.setAttribute('data-lgp-carousel-incomplete', present + '/' + total);
      }
    });
  })();

  /* --- 3. LOGO MARQUEE (n-reasons) ------------------------------------------------
   * .logos-carousel-wrapper > .logos-carousel-track x2 — the duplicate track is the
   * classic seamless-marquee pattern, so the animation is all that was missing. */
  (function marquee() {
    var wrap = document.querySelector('.logos-carousel-wrapper');
    if (!wrap || wrap.dataset.lgpMarquee) return;
    var tracks = wrap.querySelectorAll('.logos-carousel-track');
    if (tracks.length < 2) return;
    wrap.dataset.lgpMarquee = '1';
    var st = document.createElement('style');
    st.textContent =
      '@keyframes lgp-marquee{from{transform:translateX(0)}to{transform:translateX(-100%)}}' +
      '.logos-carousel-wrapper{overflow:hidden;display:flex}' +
      '.logos-carousel-track{animation:lgp-marquee 30s linear infinite;flex:0 0 auto}' +
      '@media (prefers-reduced-motion:reduce){.logos-carousel-track{animation:none}}';
    document.head.appendChild(st);
  })();

  /* --- 4. COMMENT EXPANDER (i-was-wrong) ------------------------------------------
   * a.load-more-comments says "View 839 more comments" but the export kept only the
   * comments already in the DOM. Reveal any hidden ones; if there are none to reveal,
   * REMOVE the control rather than leave a button that lies about what it does. */
  (function loadMore() {
    var btn = document.querySelector('a.load-more-comments');
    if (!btn) return;
    var hidden = [].slice.call(document.querySelectorAll('.comment.hidden, .comment[hidden], .c-item.hidden'));
    if (!hidden.length) { btn.remove(); return; }
    btn.style.cursor = 'pointer';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      hidden.splice(0, 10).forEach(function (el) {
        el.hidden = false; el.classList.remove('hidden');
      });
      if (!hidden.length) btn.remove();
    });
  })();

  
})();

